import { setLogger } from "../Logging/Logger";
import * as Logger from "../Logging/Logger";
import * as Configuration from "../Configuration/Configuration";
import { IPersonalizationConfig, IUserFactRulesMap } from "./Models";
import { getSamplingRate, initSettings } from "./Settings";
import { sendAppLastUsed } from "../Facts/UserFacts";
import { EventIds } from "../Logging/Constants";

export function initialize(config?: IPersonalizationConfig) {
	setLogger(config?.logger);
	initSettings(config?.settings);

	if (config?.sessionId) {
		Configuration.get().setSessionId(config.sessionId);
	}

	if (config?.userFactConfig?.enableSendUserFacts) {
		const currentDateTime = new Date();

		const filteredRules = filterDisabledUserFactRules(config.userFactConfig.disabledUserFacts, config.userFactConfig.userFactRules)
		Configuration.get().setUserFactRules(filteredRules);
		Logger.getLogger().event(EventIds.UserFactsConfigRules, { Message: JSON.stringify(filteredRules) }, getSamplingRate());
		
		if (config.settings?.appId) {
			sendAppLastUsed(config.settings.appId, currentDateTime);
		}
	}
}

/**
 * Removes manifests for disabled UserFacts
 * @param disabledUserFacts list of UserFacts to disable and not send
 * @param userFactRules static map of all UserFactManifests. Modifies map
 * by removing disabled userFacts
 */
export function filterDisabledUserFactRules(disabledUserFacts: string[], userFactRules: IUserFactRulesMap) : IUserFactRulesMap {
	
	const enabledRulesMap : IUserFactRulesMap = userFactRules;

	if (!userFactRules || !disabledUserFacts) {
		return enabledRulesMap;
	}

	Object.keys(enabledRulesMap).forEach(key => {
		if(disabledUserFacts.find(fact => fact == enabledRulesMap[key].userFactName)) {
			delete enabledRulesMap[key];
		}
	});

	return enabledRulesMap;
}
